<template>
  <div class="onlineDeal">
    <breadcrumb :link-list="breadcrumbList"></breadcrumb>
    <div class="mainCard">
      <div class="checkout-grid">
        <div class="checkout-main">
      <div class="product">
        <div class="section-title">
          <span></span>
          商品信息
        </div>
        <div class="info">
          <div class="product-img">
            <el-image
              style="width: 351px"
              :style="info.id_api_shangjia ? '' : 'height:196px'"
              :src="info.image"
              fit="cover"
              :preview-src-list="srcList"
            >
              <div slot="placeholder" class="image-slot">
                图片加载中<span class="dot">...</span>
              </div>
            </el-image>
          </div>
          <div class="product-info">
            <div class="product-name">
              {{ info.name }}
            </div>
            <div class="product-zone">
              <div
                v-for="(categoryItem, index) in info.category"
                :key="index"
                id="DI_prodct_zone"
              >
                <div class="zone_title">{{ categoryItem.name }}：</div>
                <div class="zone_content">{{ categoryItem.value }}</div>
              </div>
            </div>
            <div class="product-other">
              <div
                class="DI_prodct_price"
                v-if="info.price > 0 && info.bargain_price == 0"
              >
                商品价格：
                <span class="price">¥{{ info.price }}</span>
              </div>
              <div class="bargain_price" v-if="info.bargain_price > 0">
                <span class="price">商品价格： ￥{{ info.price }}</span>
                <span class="price_bargain">
                  ¥<span>{{ info.bargain_price }}</span>
                  <img
                    v-if="info.bargain_price  && !info.earnest_amount"
                    src="../../../assets/image/AllGame/onlineDeal/xsj.png"
                    alt=""
                  />
                  <img v-if="info.earnest_amount" src="@/assets/image/AllGame/onlineDeal/final-price.png" alt="">
                </span>
              </div>
              <div id="DI_prodct_hot">
                <span class="addtime">上架时间：</span>
                <span class="date">{{ info.up_time | moment }}</span>
                <img src="@/assets/image/Home/topGamesIco.png" alt="" />
                <span>{{ info.click }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="indemnification"
        v-for="(item, index) in indemnificationList"
        :key="index"
      >
        <div class="section-title">
          <span></span>
          {{ item.class_name }}
          <i class="el-icon-warning-outline" @click="descriptionPop = true;descriptionPopList = item.entries"></i>
          <div class="tips" v-if="info.game_id == 11">
            为了保障您的权益，不可二次实名的账号建议您购买一份人脸包赔，如果出现人脸/设备脸由平台帮您处理，畅玩无忧。
          </div>
        </div>
        <div class="list">
          <div
            class="item"
            :class="{
              itemChecked: indemnification[item.class_id].includes(items.id),
              disabled:
                (item.select === 'radio'
                  ? indRadioDis
                    ? items.title_id === 4
                    : false
                  : indCheckBoxDis) || items.disabled == 0
            }"
            v-for="(items, indexs) in item.entries"
            :style="{ 'margin-left': indexs % 3 === 0 ? '0px' : '18px' }"
            :key="indexs"
            @click="indemnificationClick(item, items)"
          >
            <div class="item-top">
              <div>
                <span class="top-title">{{ items.title }}</span>
                <span v-if="items.multiple" class="multiple">{{
                  items.multiple
                }}</span>
                <span v-if="items.haveCoupon" class="have-coupon">有券</span>
              </div>
              <div class="item-price">¥{{ items.amount }}</div>
            </div>
            <div class="item-middle">
              <div>
                包赔比例{{ items.percent_compensation * 1 }}%,若证实被找回,
                <span class="pf"
                  >可赔付¥{{
                    (info.bargain_price ? info.bargain_price* items.percent_compensation : info.price * items.percent_compensation) / 100
                  }}</span
                >
              </div>
              <!-- <div>{{ items.description }}</div> -->
            </div>
            <div class="item-bottom">
              <!-- <div>包赔说明：{{ items.description }}</div> -->
              <div v-if="items.title_id == 2 || items.title_id == 3">
                推荐指数:
                <span
                  ><img
                    v-for="i in items.stars"
                    :key="i"
                    src="@/assets/image/Coupon/star.png"
                    alt=""
                /></span>
              </div>
            </div>
            <div
              v-if="indemnification[item.class_id].includes(items.id)"
              class="choose"
            ></div>
          </div>
        </div>
      </div>
      <div class="coupon" v-if="!info.earnest_amount">
        <div class="coupon-title">优惠券</div>
        <div class="content">
          <div class="goods" @click="chooseCoupon(1)">
            <div class="wrapper">
              <div>
                <span class="content-name"> 商品优惠券 </span>
                <span class="content-desc">{{
                  product_coupons_length == 0
                    ? "暂无可用优惠券"
                    : currentCouponGoods.id
                    ? `已选择满${currentCouponGoods.threshold ||
                        0}减${currentCouponGoods.amount ||
                        0} ${currentCouponGoods.coupon_name || ""}`
                    : "未选择使用优惠券"
                }}</span>
              </div>
              <div class="content-price">
                {{
                  product_coupons_length == 0
                    ? "-0"
                    : `-${currentCouponGoods.amount || 0}`
                }}
                <img
                    src="@/assets/image/Coupon/blackArrow.png"
                    alt=""
                  />
              </div>
            </div>
          </div>
          <div class="bp" @click="chooseCoupon(2)">
            <div class="wrapper">
              <div>
                <span class="content-name"> 包赔优惠券 </span>
                <span class="content-desc">{{
                  currentCouponListBp.length == 0
                    ? "暂无可用优惠券"
                    : currentCouponBp.id
                    ? `已选择满${currentCouponBp.threshold ||
                        0}减${currentCouponBp.amount ||
                        0} ${currentCouponBp.coupon_name || ""}`
                    : "未选择使用优惠券"
                }}</span>
              </div>
              <div class="content-price">
                {{
                  currentCouponListBp.length == 0
                    ? "-0"
                    : `-${currentCouponBp.amount || 0}`
                }}
                <img
                    src="@/assets/image/Coupon/blackArrow.png"
                    alt=""
                  />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 安全提示条 -->
      <div class="secure-tip">
        <span class="ico">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6z"/><path d="M9 12l2 2 4-4"/></svg>
        </span>
        <span>全程 <b>站内担保托管</b>，资金安全有保障 · <b>切勿私下转账</b>，谨防绕过平台诈骗。</span>
      </div>
        </div>

        <aside class="checkout-side">
      <div class="handle">
        <div class="settle-head"><span class="b"></span><h3>结算清单</h3></div>
        <div class="agreement">
          <el-checkbox v-model="agreement"></el-checkbox>
          我同意阅读并愿意遵守
          <a @click="agreementClick">《买家交易规则》</a>
        </div>
        <div class="handle-box">
          <div class="total-price">
            <div class="details-text">
              <div class="details-text-title">
                共减￥{{ allDiscount }}, 查看明细<i class="el-icon-arrow-up"></i>
              </div>
              <div class="tips" v-if="allPayAmount==0.01"> <div class="tip-icon"></div> 订单优惠券抵扣后最低需支付0.01元</div>
              <div :class="['details-text-card',allPayAmount==0.01?'details-text-card-0':'details-text-card']">
                <div class="details-text-card-head">金额明细</div>
                <div
                  class="details-text-card-item"
                  v-show="info.price > 0 && info.bargain_price == 0"
                >
                  商品总价<span
                    ><span class="rmb">¥</span>{{ info.price }}</span
                  >
                </div>
                <div
                  class="details-text-card-item"
                  v-show="info.bargain_price > 0"
                >
                  商品最终价<span
                    ><span class="rmb">¥</span>{{ info.bargain_price }}</span
                  >
                </div>
                <div
                  class="details-text-card-item"
                  v-show="amountOfService > 0"
                >
                  账号包赔<span
                    ><span class="rmb">¥</span>{{ amountOfService }}</span
                  >
                </div>
                <div
                  class="details-text-card-item"
                  v-show="info.agent_fee_amount > 0"
                >
                  手续费用<span
                    ><span class="rmb">¥</span>{{ info.agent_fee_amount }}</span
                  >
                </div>
                <div
                  class="details-text-card-item"
                  v-show="info.earnest_amount"
                >
                  诚意买<span
                    ><span class="rmb">-</span
                    >{{
                      info.earnest_amount
                    }}</span
                  >
                </div>
                <div
                  class="details-text-card-item"
                  v-show="currentCouponGoods && currentCouponGoods.amount"
                >
                  商品优惠<span
                    ><span class="rmb">-</span
                    >{{
                      Number(currentCouponGoods && currentCouponGoods.amount)
                    }}</span
                  >
                </div>
                <div
                  class="details-text-card-item"
                  v-show="currentCouponBp && currentCouponBp.amount"
                >
                  包赔优惠<span
                    ><span class="rmb">-</span
                    >{{
                      Number(currentCouponBp && currentCouponBp.amount)
                    }}</span
                  >
                </div>
                <div class="details-text-card-item">
                  合计 <span><span class="rmb">¥</span>{{ allPayAmount }}</span>
                </div>
              </div>
            </div>
            <i v-if="info.earnest_amount" class="earnest">已付：¥{{info.earnest_amount}}</i>
            应付：
            <span>¥</span>
            <span>{{ allPayAmount }}</span>
          </div>
          <div
            class="btn"
            :class="{ notallowedBtn: !agreement || !confirmPayDis }"
            @click="confirmPay"
          >
            确认支付
          </div>
        </div>
        <div class="guard">
          <div class="gr">
            <span class="ic"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6z"/><path d="M9 12l2 2 4-4"/></svg></span>
            <span class="tx">账号被找回 · <b>全额赔付</b>，平台先行垫付</span>
          </div>
          <div class="gr">
            <span class="ic"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-3-6.7M21 3v5h-5"/><path d="M12 8v4l3 2"/></svg></span>
            <span class="tx">付款后 <b>极速交付</b> 到手，全程站内托管</span>
          </div>
        </div>
      </div>
        </aside>
      </div>
      <transition name="el-fade-in-linear">
        <div class="tooltip" v-show="tooltipShow">
          {{
            agreement && !confirmPayDis
              ? "请先选择包赔服务"
              : "请先点击《买家交易规则》"
          }}
        </div>
      </transition>
    </div>
    <couponDialog
      ref="couponDialogRef"
      :couponList="dialogData"
      :width="'482'"
      :title="dialogTitle"
      text="优惠券已放入“个人中心-我的优惠券”"
    >
    </couponDialog>

    <!--  包赔类型说明  -->
    <el-dialog
      :visible.sync="descriptionPop"
      custom-class="descriptionPop"
      :show-close="false"
      width="350px"
      top="35vh"
      center
    >
      <div id="descriptionPop">
        <div class="descriptionPopHead">
          包赔类型说明
        </div>
        <div class="descriptionPop-list" v-for="(item,index) in descriptionPopList" :key="index">
          <div class="descriptionPop-title">{{item.multiple || item.title}}</div>
          <div class="descriptionPop-text">{{item.description}}</div>
        </div>
        <div class="descriptionPop-btn" @click="descriptionPop = false;descriptionPopList = []">我知道了</div>
        <img
          class="descriptionPop-close"
          src="../../../assets/image/AccountDeal/close.png"
          alt=""
          @click="descriptionPop = false;descriptionPopList = []"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumb from "@/components/breadcrumb";
import {
  apiProductBuy,
  apiConfirmPayment,
  apiPaydetail,
  apiPayQuery,
  apiPaySwitch
} from "@/request/API";
import { accAdd, accSub } from "@/util/calculate";
import couponDialog from "./couponDialog.vue";

export default {
  name: "onlineDealNew",
  props: {},
  components: { breadcrumb, couponDialog },
  data() {
    return {
      breadcrumbList: [
        { link: "AllGame", name: "全部游戏" },
        {
          link: "SelectGame",
          name: null,
          query: {
            game_alias: "games",
            game_id: this.$route.query.game_id
          }
        },
        {
          link: "GameDetails",
          name: "账号详情",
          query: {
            id: this.$route.query.id,
            game_id: this.$route.query.game_id,
            source_page: this.$route.path.slice(1)
          }
        },
        { name: "支付确认" }
      ],
      //游戏id
      game_id: this.$route.query.game_id,
      //商品id
      id: this.$route.query.id,
      //账号包赔
      indemnificationList: [],
      indRadioDis: false,
      indCheckBoxDis: false,
      //买家协议
      agreement: false,
      //文字提醒
      tooltipShow: false,
      //包赔选项
      indemnification: {},
      info: {},
      srcList: [],
      //合计价格
      total: 0,
      //服务项金额
      amountOfService: 0,
      //确认支付按钮disabled
      confirmPayDis: false,
      showCouponDialog: false,
      //优惠券类型 1.商品 2.包赔
      couponType: 1,
      //所有优惠券信息
      coupon_info: {},
      //弹窗数据
      dialogData: [],
      //弹窗标题
      dialogTitle: '',
      //可用包赔券列表
      currentCouponListBp: [],
      //当前选择的商品优惠券
      currentCouponGoods: {},
      //当前选择的包赔优惠券
      currentCouponBp: {},
      //商品优惠券列表
      product_coupons: [],
      //记录当前选择的普通包赔选项
      currentIndex:0,
      //包赔类型说明
      descriptionPop:false,
      descriptionPopList:[],
      earnest_order_id:''
    };
  },
  methods: {
    /**
     * 确认支付
     */
    confirmPay() {
      if (!this.agreement || !this.confirmPayDis) {
        this.tooltipShow = true;
        setTimeout(() => {
          this.tooltipShow = false;
        }, 2000);
        return;
      } else {
        apiConfirmPayment({
          game_id: this.game_id,
          id: this.id,
          amount: this.allPayAmount,
          indemnity_id: this.indemnification,
          earnest_order_id: this.earnest_order_id,
          product_coupon_id:
            this.currentCouponGoods && this.currentCouponGoods.id,
          indemnity_coupon_id: this.currentCouponBp && this.currentCouponBp.id
        })
          .then(res => {
            this.$router.push({
              name: "MethodOfPayment",
              query: {
                type: 1,
                orderid: res.data.id,
                id: this.id,
                gameid: this.game_id,
                amount: this.allPayAmount,
                earnest_order_id: this.earnest_order_id,
              }
            });
            /*          this.$router.replace({
                      name: 'Payment',
                      query: {
                        orderid: res.data.id,
                        id: this.id,
                        game_id: this.game_id,
                      }
                    })*/
            /*          apiPaySwitch({
                      game_id: this.game_id,
                      type: 1
                    }).then(ress => {
                      if (ress.data.is_lianlian_pay == 1) {
                        this.$router.push({
                          name: 'MethodOfPayment',
                          query: {
                            type: 1,
                            orderid: res.data.id,
                            id: this.id,
                            gameid: this.game_id,
                            amount: this.total
                          }
                        })
                      } else {
                        this.paydetail(res.data.id)
                      }
                    })*/
          })
          .catch(e => {
            //优惠券过期重新刷新数据
            this.getProductBuyInfo();
            this.$message({
              center: true,
              type: "error",
              message: e.msg
            });
          })
          .finally(f => {});
      }
    },
    /**
     * 账号包赔选项
     * @param item
     * @param items
     */
    indemnificationClick(item, items) {
      for(let k in this.indemnificationList[0].entries){
        if(items.id == this.indemnificationList[0].entries[k].id){
          this.currentIndex = k
        }
      }
      if (items.disabled == 0) {
        return;
      }
      if (item.select === "radio" && this.indRadioDis && items.title_id === 4) {
        return;
      }
      if (item.select == "checkbox" && this.indCheckBoxDis) {
        return;
      }

      for (let indemnityKey in this.indemnification) {
        if (indemnityKey == item.class_id) {
          if (
            this.indemnification[indemnityKey].findIndex(
              val => val == items.id
            ) > -1
          ) {
            if (item.select === "radio") {
              return;
            }
            this.indemnification[indemnityKey].splice(
              this.indemnification[indemnityKey].findIndex(
                val => val == items.id
              ),
              1
            );
            this.total = accSub(this.total, items.amount);
            this.amountOfService = accSub(this.amountOfService, items.amount);
            this.confirmPayDis = false;
            if (item.select === "checkbox") {
              if (this.indemnification[indemnityKey].length === 0) {
                this.indRadioDis = false;
              }
            }
          } else {
            if (item.select === "radio") {
              if (items.title_id == "4") {
                this.indCheckBoxDis = true;
              } else {
                this.indCheckBoxDis = false;
              }
            } else if (item.select == "checkbox") {
              this.indRadioDis = true;
            }
            if (this.indemnification[indemnityKey].length > 0) {
              if (item.select === "radio") {
                item.entries.forEach(i => {
                  if (i.id === this.indemnification[indemnityKey][0]) {
                    this.total = accSub(this.total, i.amount);
                    this.amountOfService = accSub(
                      this.amountOfService,
                      i.amount
                    );
                  }
                });
                this.indemnification[indemnityKey] = [];
              }
            }
            this.indemnification[indemnityKey].push(items.id);
            this.total = accAdd(this.total, items.amount);
            this.amountOfService = accAdd(this.amountOfService, items.amount);
          }
        }
        if (this.indemnification[indemnityKey].length > 0) {
          this.confirmPayDis = true;
        }
      }
      if (items.basePb) {
        this.currentCouponListBp = [];
        this.currentCouponBp = {};
        if (items.haveCoupon) {
          this.currentCouponListBp = items.couponList;
          this.currentCouponBp = items.couponList[0];
        }
      }
      for (let indemnityKey in this.indemnification) {
        if (this.indemnification[indemnityKey].length > 0) {
          this.confirmPayDis = true;
          return;
        } else {
          this.confirmPayDis = false;
        }
      }
    },

    /**
     * 获取包赔信息
     */
    applyProductBuyInfo(productInfo) {
      this.indemnificationList = [];
      this.indemnification = {};
      this.indRadioDis = false;
      this.indCheckBoxDis = false;
      this.confirmPayDis = false;
      this.amountOfService = 0;
      this.currentCouponListBp = [];
      this.currentCouponBp = {};
      this.srcList = [];
      // earnest_order_id   求降价不能选择优惠券   支持优惠券后放开
      this.coupon_info = this.earnest_order_id ? {} : productInfo.coupon_info;
      this.currentCouponGoods = this.earnest_order_id ? {} : this.coupon_info.product_coupons[0];
      this.breadcrumbList[1].name = productInfo.game_name;
      this.total =
        productInfo.bargain_price * 1 > 0
          ? productInfo.bargain_price * 1 + productInfo.agent_fee_amount
          : productInfo.price * 1 + productInfo.agent_fee_amount;
      this.info = productInfo;
      this.srcList.push(productInfo.image);
      if (productInfo.indemnity.length > 0) {
        let data = JSON.parse(JSON.stringify(productInfo));
        data.indemnity[0].entries = data.indemnity[0].entries.map(v => {
          v.basePb = true;
          if (v.title == "双倍包赔" || v.title == "三倍包赔") {
            v.title = "安心买";
          }
          if (v.title_id == 2) {
            v.multiple = "双倍包赔";
            v.stars = 3;
          }
          if (v.title_id == 3) {
            v.multiple = "三倍包赔";
            v.stars = 5;
          }
          // earnest_order_id   求降价不能选择优惠券   支持优惠券后放开
          if (!this.earnest_order_id) {
            for (let k of productInfo.coupon_info.indemnity_coupons) {
              if (k.indemnity_id == v.id && k.coupon_list.length != 0) {
                v.haveCoupon = true;
                v.couponList = k.coupon_list;
              }
            }
          }

          return v;
        });
        this.indemnificationList = data.indemnity;
        for (let indemnityKey in data.indemnity) {
          this.$set(
            this.indemnification,
            data.indemnity[indemnityKey].class_id,
            []
          );
        }
        this.indemnificationClick(
          data.indemnity[0],
          data.indemnity[0].entries[this.currentIndex]
        );
      } else {
        this.confirmPayDis = true;
      }
    },
    getProductBuyInfo() {
      apiProductBuy({
        game_id: this.game_id,
        id: this.id,
        earnest_order_id: this.earnest_order_id
      }).then(res => {
        this.applyProductBuyInfo(res.data);
      });
    },
    /**
     * 购买协议
     */
    agreementClick() {
      let routeData = this.$router.resolve({
        name: "Agreement",
        query: {
          id: this.info.agreement.id
        }
      });
      window.open(routeData.href, "_blank");
    },

    /**
     * 生成订单跳转支付宝收银台
     * @param orderid 订单id
     */
    paydetail(orderid) {
      apiPaydetail({
        id: orderid,
        return_url: `${process.env.VUE_APP_WEBSITE}/payment?orderid=${orderid}&id=${this.id}&game_id=${this.game_id}`
      }).then(res => {
        this.alipayFrom = res.data.from_data;
        const div = document.createElement("divform");
        div.innerHTML = res.data.from_data;
        document.body.appendChild(div);
        document.forms[0].acceptCharset = "GBK"; // 保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
        document.forms[0].submit();
        div.remove();
      });
    },
    chooseCoupon(type) {
      this.couponType = type;
      this.dialogData = [];
      if (type == 1) {
        this.dialogTitle = '选择商品优惠券'
        if (this.coupon_info.product_coupons.length != 0) {
          this.dialogData = this.coupon_info.product_coupons;
          this.$refs.couponDialogRef.showDialog(this.currentCouponGoods);
        }
      } else {
        this.dialogTitle = '选择包赔优惠券'
        if (this.currentCouponListBp.length != 0) {
          this.dialogData = this.currentCouponListBp;
          this.$refs.couponDialogRef.showDialog(this.currentCouponBp);
        }
      }
    },
    cancel() {
      this.$refs.couponDialogRef.close();
    },
    ChooseCouponNow(item) {
      if (this.couponType == 1) {
        this.currentCouponGoods = item;
      } else {
        this.currentCouponBp = item;
      }
    },
    useNow() {}
  },
  watch: {},
  created() {
    this.currentIndex = 0
    //  求降价  尾款支付完需跳至新的结果页
    this.earnest_order_id = this.$route.query?.earnest_order_id || ''
     this.getProductBuyInfo();
  },
  mounted() {},
  computed: {
    allPayAmount() {
      //价格最低为0.01元
      let sum =
        accAdd(this.total, -this.allDiscount) == 0
          ? 0.01
          : accAdd(this.total, -this.allDiscount);
      return sum;
    },
    allDiscount(){
      let discount = 0;
      // earnest_order_id   求降价不能选择优惠券   支持优惠券后放开
      if (this.currentCouponBp && this.currentCouponBp.amount &&  !this.earnest_order_id) {
        discount += Number(this.currentCouponBp.amount);
      }
      // earnest_order_id   求降价不能选择优惠券   支持优惠券后放开
      if (this.currentCouponGoods && this.currentCouponGoods.amount  &&  !this.earnest_order_id) {
        discount += Number(this.currentCouponGoods.amount);
      }
      if(this.earnest_order_id) {
        discount += Number(this.info.earnest_amount)
      }
      return discount
    },
    product_coupons_length() {
      return (
        this.coupon_info.product_coupons &&
        this.coupon_info.product_coupons.length
      );
    }
  }
};
</script>

<style scoped lang="less">
.onlineDeal {
  width: 1200px;
  max-width: 100%;
  box-sizing: border-box;
  padding-bottom: 32px;

  .mainCard {
    position: relative;
    box-sizing: border-box;
    padding: 24px;
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

    .section-title {
      display: flex;
      align-items: center;
      min-height: 28px;
      margin: 0 0 16px;
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 800;
      letter-spacing: -0.3px;
      color: var(--text-main, #1A1D24);
      line-height: 28px;

      span {
        display: inline-block;
        width: 5px;
        height: 17px;
        margin: 0 11px 0 0;
        background: var(--bg-dark, #1A1D24);
        border-radius: 0;
        transform: skewX(-12deg);
      }

      i {
        margin: 0 0 0 8px;
        font-size: 18px;
        color: var(--text-secondary, #5A5F6B);
        cursor: pointer;
        transition: color 0.2s ease;
      }

      i:hover {
        color: var(--primary, #FF5A1F);
      }
    }

    .product {
      margin: 0 0 24px;

      .info {
        display: flex;
        align-items: stretch;
        gap: 24px;
      }

      .product-img {
        flex: 0 0 351px;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 196px;
        overflow: hidden;
        background: var(--bg-section, #F7F5F2);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;

        /deep/ .el-image {
          display: block;
          width: 100% !important;
          min-height: 196px;
          border-radius: 4px;
        }

        /deep/ .el-image__inner {
          display: block;
        }

        .image-slot {
          min-height: 196px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: var(--text-muted, #9AA0AC);
          background: var(--bg-section, #F7F5F2);
        }
      }

      .product-info {
        flex: 1 1 auto;
        min-width: 0;
        display: flex;
        flex-direction: column;

        .product-name {
          min-height: 52px;
          margin: 0 0 14px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: var(--text-main, #111827);
          line-height: 26px;
        }

        .product-zone {
          min-height: 82px;
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 10px 12px;
        }

        #DI_prodct_zone {
          box-sizing: border-box;
          min-height: 36px;
          padding: 7px 10px;
          display: flex;
          align-items: center;
          min-width: 0;
          background: var(--bg-section, #F7F5F2);
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;

          .zone_title,
          .zone_content {
            font-size: 13px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            line-height: 20px;
          }

          .zone_title {
            flex: 0 0 auto;
            max-width: 84px;
            color: var(--text-muted, #9AA0AC);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .zone_content {
            min-width: 0;
            color: var(--text-main, #111827);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .product-other {
          box-sizing: border-box;
          min-height: 76px;
          margin: 16px 0 0;
          padding: 14px 18px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 18px;
          background: var(--bg-tag, #F0EDE8);
          border: 1px solid var(--border-soft, #E8E4DE);
          border-left: 3px solid var(--primary, #FF5A1F);
          border-radius: 4px;

          .DI_prodct_price,
          .bargain_price {
            min-width: 0;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);
          }

          .DI_prodct_price > .price {
            margin-left: 8px;
            font-size: 30px;
            font-family: PingFang SC, PingFang SC-Semibold;
            font-weight: 900;
            letter-spacing: -0.5px;
            color: var(--primary, #FF5A1F);
            line-height: 36px;
          }

          .bargain_price {
            display: flex;
            align-items: baseline;
            flex-wrap: wrap;
            gap: 8px 16px;

            > .price {
              font-size: 14px;
              color: var(--text-muted, #9AA0AC);
              text-decoration-line: line-through;
            }

            > .price_bargain {
              display: inline-flex;
              align-items: center;
              gap: 6px;
              font-size: 20px;
              font-family: PingFang SC, PingFang SC-Semibold;
              font-weight: 900;
              color: var(--primary, #FF5A1F);

              span {
                font-size: 30px;
                line-height: 36px;
              }

              img {
                width: 58px;
                height: 19px;
                object-fit: contain;
              }
            }
          }

          #DI_prodct_hot {
            flex: 0 0 auto;
            display: flex;
            align-items: center;
            padding: 8px 12px;
            background: #FFFFFF;
            border: 1px solid rgba(26, 29, 36, 0.10);
            border-radius: 4px;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);

            .addtime,
            .date {
              margin-right: 8px;
              font-size: 13px;
              color: var(--text-secondary, #5A5F6B);
            }

            .date {
              color: var(--text-main, #111827);
            }

            img {
              width: 16px;
              height: 18px;
              margin: 0 5px 0 2px;
              object-fit: contain;
            }
          }
        }
      }
    }

    .indemnification {
      margin: 0 0 24px;

      .section-title {
        flex-wrap: wrap;
        gap: 0 8px;
      }

      .tips {
        flex: 1 1 100%;
        box-sizing: border-box;
        margin: 10px 0 0 14px;
        padding: 8px 12px;
        background: var(--warning-soft, #FFFBEB);
        border: 1px solid rgba(245, 158, 11, 0.18);
        border-radius: 4px;
        font-size: 13px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
        line-height: 20px;
      }

      .list {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 16px;
      }

      .item {
        position: relative;
        box-sizing: border-box;
        min-height: 112px;
        margin: 0 !important;
        padding: 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        overflow: hidden;
        background: var(--bg-section, #F7F5F2);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        cursor: pointer;
        transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;

        .item-top {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 12px;
          width: 100%;

          > div:first-child {
            min-width: 0;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 6px;
          }

          .top-title {
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 15px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            color: var(--text-main, #111827);
          }

          .have-coupon,
          .multiple {
            flex: 0 0 auto;
            height: 20px;
            padding: 0 7px;
            border-radius: 4px;
            font-size: 12px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            line-height: 20px;
          }

          .have-coupon {
            color: var(--primary, #FF5A1F);
            background: var(--primary-soft, #FCEDE5);
            border: 1px solid var(--primary, #FF5A1F);
          }

          .multiple {
            color: var(--text-secondary, #5A5F6B);
            background: var(--bg-tag, #F0EDE8);
            border: 1px solid var(--border-soft, #E8E4DE);
          }

          .item-price {
            flex: 0 0 auto;
            font-size: 20px;
            font-family: PingFang SC, PingFang SC-Semibold;
            font-weight: 900;
            color: var(--primary, #FF5A1F);
            line-height: 24px;
          }
        }

        .item-middle,
        .item-bottom {
          width: 100%;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
        }

        .item-middle {
          margin: 8px 0 0;
          font-size: 13px;
          line-height: 20px;

          .pf {
            color: var(--primary, #FF5A1F);
            font-weight: 700;
          }
        }

        .item-bottom {
          min-height: 20px;
          margin: 6px 0 0;
          font-size: 12px;
          line-height: 20px;

          img {
            margin-right: 3px;
            vertical-align: -1px;
          }
        }

        .choose {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 38px;
          height: 31px;
          background: url("../../../assets/image/Coupon/chooseTag.png") no-repeat center / cover;
        }
      }

      .item:hover {
        background: #FFFFFF;
        border-color: var(--border-strong, #D8D2CA);
        box-shadow: var(--shadow-card, 0 8px 22px rgba(26, 29, 36, 0.08));

        .item-top .top-title {
          color: var(--text-main, #1A1D24);
        }
      }

      .itemChecked {
        background: var(--primary-soft, #FCEDE5);
        border-color: var(--primary, #FF5A1F);

        .item-top .top-title {
          color: var(--text-main, #1A1D24);
        }
      }

      .disabled {
        background: var(--bg-tag, #F0EDE8);
        border-color: var(--border-soft, #E8E4DE);
        box-shadow: none;
        cursor: not-allowed;
        opacity: 0.68;

        * {
          color: var(--text-muted, #9AA0AC) !important;
        }
      }
    }

    .coupon {
      box-sizing: border-box;
      margin: 0 0 24px;
      overflow: hidden;
      background: var(--bg-section, #F7F5F2);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;

      .coupon-title {
        height: 52px;
        padding: 0 20px;
        display: flex;
        align-items: center;
        background: #FFFFFF;
        border-bottom: 1px solid var(--border-soft, #E8E4DE);
        font-size: 18px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        color: var(--text-main, #111827);
      }

      .content {
        padding: 14px 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        color: var(--text-secondary, #5A5F6B);
        font-size: 14px;
      }

      .goods,
      .bp {
        border-radius: 4px;
        cursor: pointer;
        transition: box-shadow 0.2s ease;
      }

      .wrapper {
        min-height: 56px;
        box-sizing: border-box;
        padding: 0 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 18px;
        background: #FFFFFF;
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

        > div:first-child {
          min-width: 0;
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .content-name {
          flex: 0 0 auto;
          color: var(--text-main, #111827);
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
        }

        .content-desc {
          min-width: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: var(--text-muted, #9AA0AC);
        }

        .content-price {
          flex: 0 0 auto;
          display: flex;
          align-items: center;
          gap: 8px;
          color: var(--primary, #FF5A1F);
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 800;

          img {
            width: 12px;
            height: 12px;
            opacity: 0.55;
          }
        }
      }

      .goods:hover,
      .bp:hover {
        box-shadow: var(--shadow-card, 0 8px 22px rgba(26, 29, 36, 0.08));

        .wrapper {
          background: var(--bg-tag, #F0EDE8);
          border-color: var(--border-strong, #D8D2CA);
        }

        .content-name {
          color: var(--text-main, #1A1D24);
        }

        .content-price img {
          opacity: 0.78;
        }
      }
    }

    .checkout-grid {
      display: grid;
      grid-template-columns: minmax(0, 1fr) 340px;
      gap: 20px;
      align-items: start;
    }

    .checkout-main {
      min-width: 0;
    }

    .checkout-side {
      position: sticky;
      top: 14px;
      align-self: start;
    }

    .secure-tip {
      box-sizing: border-box;
      margin: 4px 0 0;
      padding: 12px 14px;
      display: flex;
      align-items: center;
      gap: 10px;
      background: var(--bg-tag, #F0EDE8);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-left: 3px solid var(--primary, #FF5A1F);
      border-radius: 4px;
      font-size: 13px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      line-height: 20px;

      .ico {
        flex: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: var(--primary, #FF5A1F);
      }

      b {
        color: var(--text-main, #1A1D24);
        font-weight: 800;
      }
    }

    .handle {
      box-sizing: border-box;
      margin: 0;
      padding: 0 0 16px;
      display: flex;
      flex-direction: column;
      gap: 16px;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;

      .settle-head {
        display: flex;
        align-items: center;
        gap: 9px;
        padding: 15px 18px;
        border-bottom: 1px solid var(--border-soft, #E8E4DE);

        .b {
          width: 5px;
          height: 17px;
          flex: none;
          background: var(--bg-dark, #1A1D24);
          transform: skewX(-12deg);
        }

        h3 {
          margin: 0;
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 900;
          letter-spacing: -0.3px;
          color: var(--text-main, #1A1D24);
        }
      }

      .agreement {
        order: 1;
        min-width: 0;
        margin: 0 18px;
        display: flex;
        align-items: center;
        font-size: 13px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);

        a {
          color: var(--primary, #FF5A1F);
          cursor: pointer;
        }

        a:hover {
          color: var(--primary-hover, #E84A12);
        }

        /deep/ .el-checkbox {
          margin: 0 8px 0 0;
        }

        /deep/ .el-checkbox__inner {
          width: 16px;
          height: 16px;
          border-color: var(--border-strong, #D8D2CA);
          border-radius: 3px !important;
        }

        /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
          background-color: var(--primary, #FF5A1F);
          border-color: var(--primary, #FF5A1F);
        }
      }

      .handle-box {
        order: 2;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 14px;
        margin: 0 18px;
      }

      .total-price {
        position: relative;
        display: flex;
        align-items: baseline;
        flex-wrap: wrap;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 800;
        color: var(--text-main, #111827);
        text-align: left;

        .details-text {
          position: relative;
          flex: 1 1 100%;
          display: inline-block;
          margin: 0 0 6px;
          text-align: right;
          cursor: pointer;

          .details-text-title {
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: var(--primary, #FF5A1F);
            line-height: 20px;
          }

          .tips {
            margin-top: 4px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            font-size: 12px;
            font-weight: 400;
            color: var(--text-muted, #9AA0AC);

            .tip-icon {
              width: 15px;
              height: 15px;
              margin-right: 6px;
              background: url("../../../assets/image/Coupon/warnnigTip.png") no-repeat center / contain;
            }
          }

          .details-text-card {
            position: absolute;
            right: 0;
            bottom: 34px;
            z-index: 10;
            display: none;
            box-sizing: border-box;
            width: 240px;
            max-height: 260px;
            padding: 16px;
            overflow: auto;
            background: #FFFFFF;
            border: 1px solid var(--border-soft, #E8E4DE);
            border-radius: 4px;
            box-shadow: var(--shadow-card, 0 8px 22px rgba(26, 29, 36, 0.08));

            .details-text-card-head {
              margin: 0 0 10px;
              font-size: 15px;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              color: var(--text-main, #111827);
              line-height: 22px;
              text-align: left;
            }

            .details-text-card-item {
              min-height: 30px;
              padding: 6px 0;
              display: flex;
              align-items: center;
              justify-content: space-between;
              gap: 16px;
              border-bottom: 1px solid var(--border-soft, #E8E4DE);
              font-size: 13px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: var(--text-secondary, #5A5F6B);
              line-height: 18px;

              span {
                flex: 0 0 auto;
                font-size: 15px;
                font-family: PingFang SC, PingFang SC-Medium;
                font-weight: 500;
                color: var(--text-main, #111827);

                .rmb {
                  margin: 0 2px 0 0;
                  font-size: 12px;
                }
              }
            }

            .details-text-card-item:last-of-type {
              border-bottom: none;

              span {
                color: var(--primary, #FF5A1F);
                font-weight: 900;
              }
            }

            &::before {
              position: absolute;
              right: 44px;
              bottom: -7px;
              width: 12px;
              height: 12px;
              content: "";
              background: #FFFFFF;
              border-right: 1px solid var(--border-soft, #E8E4DE);
              border-bottom: 1px solid var(--border-soft, #E8E4DE);
              transform: rotate(45deg);
            }
          }

          .details-text-card-0 {
            bottom: 50px;
          }

          &:hover {
            .details-text-card {
              display: block;
            }
          }
        }

        span:nth-of-type(1) {
          align-self: flex-end;
          margin-left: auto;
          font-size: 20px;
          font-weight: 800;
          color: var(--primary, #FF5A1F);
        }

        span:nth-of-type(2) {
          font-size: 38px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: 900;
          letter-spacing: -1.5px;
          color: var(--primary, #FF5A1F);
          line-height: 1;
        }
      }

      .btn {
        width: 100%;
        height: 48px;
        border-radius: 3px;
        background: var(--primary, #FF5A1F);
        cursor: pointer;
        text-align: center;
        font-size: 18px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 800;
        color: #FFFFFF;
        line-height: 48px;
        user-select: none;
        transition: background-color 0.2s ease;
      }

      .btn:hover {
        background: var(--primary-hover, #E84A12);
      }

      .notallowedBtn,
      .notallowedBtn:hover {
        background: var(--border-strong, #D8D2CA);
        box-shadow: none;
        cursor: not-allowed;
      }

      .guard {
        order: 3;
        margin: 2px 18px 0;
        overflow: hidden;
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;

        .gr {
          display: flex;
          align-items: center;
          gap: 11px;
          padding: 11px 13px;
          border-bottom: 1px solid var(--border-soft, #E8E4DE);

          &:last-child {
            border-bottom: 0;
          }

          .ic {
            width: 30px;
            height: 30px;
            flex: none;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            background: var(--bg-dark, #1A1D24);
            color: var(--gold, #C9974D);
          }

          .tx {
            font-size: 13px;
            color: var(--text-secondary, #5A5F6B);
            line-height: 1.4;

            b {
              color: var(--text-main, #1A1D24);
              font-weight: 800;
            }
          }
        }
      }
    }

    @media (max-width: 1080px) {
      .checkout-grid {
        grid-template-columns: 1fr;
      }

      .checkout-side {
        position: static;
      }
    }

    .tooltip {
      position: absolute;
      top: 22px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 20;
      padding: 8px 12px;
      border-radius: 4px;
      background: var(--bg-dark, #1A1D24);
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 20px;
      white-space: nowrap;
    }
  }
}

/deep/ .el-dialog__header,
/deep/ .el-dialog__body {
  padding: 0 !important;
}

/deep/ .descriptionPop {
  overflow: visible;
  border-radius: 4px;
  border: 1px solid var(--border-soft, #E8E4DE);
  box-shadow: 0 12px 32px rgba(26, 29, 36, 0.12);

  #descriptionPop {
    position: relative;
    padding: 24px 24px 22px;
    background: var(--bg-card, #FFFFFF);
    border-radius: 4px;

    .descriptionPopHead {
      position: relative;
      min-height: 28px;
      padding-left: 15px;
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 800;
      letter-spacing: -0.3px;
      color: var(--text-main, #1A1D24);
      line-height: 26px;
      text-align: left;
    }

    .descriptionPopHead::before {
      position: absolute;
      left: 0;
      top: 4px;
      width: 5px;
      height: 17px;
      content: "";
      background: var(--bg-dark, #1A1D24);
      border-radius: 0;
      transform: skewX(-12deg);
    }

    .descriptionPop-list {
      margin: 14px 0 0;
      padding: 12px 0 0;
      background: var(--bg-section, #F7F5F2);
      border-top: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 0;

      .descriptionPop-title {
        font-size: 15px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        color: var(--text-main, #111827);
        line-height: 22px;
      }

      .descriptionPop-text {
        margin: 6px 0 0;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
        line-height: 22px;
      }
    }

    .descriptionPop-list:first-of-type {
      margin-top: 18px;
      padding-top: 0;
      border-top: none;
    }

    .descriptionPop-btn {
      width: 100%;
      height: 42px;
      margin: 22px 0 0;
      background: var(--bg-dark, #1A1D24);
      border: 1.5px solid var(--bg-dark, #1A1D24);
      border-radius: 3px;
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 800;
      color: #FFFFFF;
      line-height: 42px;
      text-align: center;
      cursor: pointer;
      transition: color 0.2s ease, border-color 0.2s ease;
    }

    .descriptionPop-btn:hover {
      border-color: var(--primary, #FF5A1F);
      color: var(--primary, #FF5A1F);
    }

    .descriptionPop-close {
      position: absolute;
      right: 14px;
      top: 14px;
      width: 22px;
      height: 22px;
      opacity: 0.56;
      cursor: pointer;
      transition: opacity 0.2s ease;
    }

    .descriptionPop-close:hover {
      opacity: 0.88;
    }
  }
}

.earnest {
  margin-right: 12px;
  font-size: 16px !important;
  font-family: PingFang SC, PingFang SC-Medium;
  font-style: normal;
  font-weight: 500 !important;
  color: var(--text-muted, #9AA0AC) !important;
}
</style>
